import React from 'react';

import DevelopAccountPageBody from './body';

export default function DevelopAccountScreen() {
  return <DevelopAccountPageBody />;
}
